const localStorageKeys = {
  TOKEN: 'Token',
  USER_INFO: 'UserInfo',
  CPW: 'Cpw'
}

const sessionStorageKeys = {
}

export { localStorageKeys, sessionStorageKeys }
